/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Audio_Description_Export_Status_Video_Encoding_Extended_ProgressInputs */



/**
* | output |
* | --- |
* | "Encoding extended AD video: {percent}%" |
*
* @param {Audio_Description_Export_Status_Video_Encoding_Extended_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_video_encoding_extended_progress = /** @type {((inputs: Audio_Description_Export_Status_Video_Encoding_Extended_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Video_Encoding_Extended_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Encodage de la vidéo AD étendue : ${i?.percent}%`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Kodierung von erweitertem AD-Video: ${i?.percent}%`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Codifica video AD esteso: ${i?.percent}%`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Кодирование расширенного рекламного видео: ${i?.percent}%`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Codificación de vídeo AD extendido: ${i?.percent}%`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`编码扩展广告视频：${i?.percent}%`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`拡張ADビデオのエンコード: ${i?.percent}%`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`विस्तारित विज्ञापन वीडियो को एन्कोड करना: ${i?.percent}%`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Codificação de vídeo AD estendido: ${i?.percent}%`)
	return /** @type {LocalizedString} */ (`Encoding extended AD video: ${i?.percent}%`)
});